import React from 'react';

const ChannelIcon: React.FC<{ channel: string; className?: string }> = ({ channel, className = 'w-5 h-5' }) => {
  switch (channel) {
    case 'instagram':
      return (
        <svg className={className} viewBox="0 0 24 24" fill="none">
          <defs>
            <linearGradient id={`ig-grad-${channel}`} x1="0%" y1="100%" x2="100%" y2="0%">
              <stop offset="0%" stopColor="#FFC107" />
              <stop offset="50%" stopColor="#F44336" />
              <stop offset="100%" stopColor="#9C27B0" />
            </linearGradient>
          </defs>
          <rect x="2" y="2" width="20" height="20" rx="5" stroke={`url(#ig-grad-${channel})`} strokeWidth="2" />
          <circle cx="12" cy="12" r="4.5" stroke={`url(#ig-grad-${channel})`} strokeWidth="2" />
          <circle cx="17.5" cy="6.5" r="1.5" fill={`url(#ig-grad-${channel})`} />
        </svg>
      );
    case 'blog':
      return (
        <svg className={className} viewBox="0 0 24 24" fill="none">
          <rect x="2" y="2" width="20" height="20" rx="4" fill="#03C75A" />
          <text x="12" y="16" textAnchor="middle" fill="white" fontSize="11" fontWeight="bold" fontFamily="Arial">B</text>
        </svg>
      );
    case 'youtube':
      return (
        <svg className={className} viewBox="0 0 24 24" fill="none">
          <path d="M22.54 6.42a2.78 2.78 0 0 0-1.94-2C18.88 4 12 4 12 4s-6.88 0-8.6.46a2.78 2.78 0 0 0-1.94 2A29 29 0 0 0 1 12a29 29 0 0 0 .46 5.58 2.78 2.78 0 0 0 1.94 2C5.12 20 12 20 12 20s6.88 0 8.6-.46a2.78 2.78 0 0 0 1.94-2A29 29 0 0 0 23 12a29 29 0 0 0-.46-5.58z" fill="#FF0000" />
          <polygon points="9.75,8.27 15.5,12 9.75,15.73" fill="white" />
        </svg>
      );
    default:
      return null;
  }
};

export default ChannelIcon;
